// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__Rps9G","tab":"ProcedureTabs_tab__yPFc4"};